import { render, staticRenderFns } from "./scroll-view.vue?vue&type=template&id=0863c1b2&scoped=true"
import script from "./scroll-view.vue?vue&type=script&lang=js"
export * from "./scroll-view.vue?vue&type=script&lang=js"
import style0 from "./scroll-view.vue?vue&type=style&index=0&id=0863c1b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0863c1b2",
  null
  
)

export default component.exports